import { render, staticRenderFns } from "./cascadePage.vue?vue&type=template&id=2cfa8e4a&scoped=true"
import script from "./cascadePage.vue?vue&type=script&lang=js"
export * from "./cascadePage.vue?vue&type=script&lang=js"
import style0 from "./cascadePage.vue?vue&type=style&index=0&id=2cfa8e4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa8e4a",
  null
  
)

export default component.exports